import React from 'react';

import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form';

const EmailFieldList = ({ control, name, placeholder }) => {
    const { t } = useTranslation();
    const { fields, append, remove } = useFieldArray({
        control,
        name, // "emails"
    });

    // Opciones ficticias para email_type (ajusta según tus necesidades)
    const emailTypeOptions = [
        { label: t('Work'), value: 'work' },
        { label: t('Personal'), value: 'personal' },
    ];

    return (
        <>
            {fields.map((field, index) => (
                <Box alignItems="center" display="flex" gap={2} key={field.id}>
                    <ReactHookFormInput
                        control={control}
                        name={`${name}.${index}.email`}
                        placeholder={`${placeholder} #${index + 1}`}
                    />
                    <ReactHookFormSelect
                        control={control}
                        name={`${name}.${index}.email_type`}
                        options={emailTypeOptions}
                        sx={{ minWidth: '120px' }}
                    />
                    {index > 0 && (
                        <Button
                            color="secondary"
                            onClick={() => remove(index)}
                            variant="text"
                        >
                            {t('Delete')}
                        </Button>
                    )}
                </Box>
            ))}
            <Box sx={{ textAlign: 'right' }}>
                <Button
                    color="secondary"
                    onClick={() => append({ email: '', email_type: '' })}
                    variant="text"
                >
                    {t('Add email')}
                </Button>
            </Box>
        </>
    );
};

EmailFieldList.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
};

export default EmailFieldList;
